import { cn } from '@/lib/utils';

// The brand tagline lockup, in the eyebrow treatment (DESIGN.md §9). One
// component for every surface that shows it — splashes, lander headers and
// lander footers — so the family, tracking and color can't drift apart again.
const TAGLINE = 'The wallet for winning';

export function Tagline({
  rules,
  compact = false,
  className
}: {
  // Hairline rules flanking the lockup: 'fixed' for a splash, 'flex' to span
  // the column. Omitted where a logo + vertical divider already anchors it.
  rules?: 'fixed' | 'flex';
  // The /play footer's tighter scale — the one exception to text-xs, so the
  // lockup still fits beside the logo on a narrow phone.
  compact?: boolean;
  // Spacing is the caller's — the lockup itself owns only its own type.
  className?: string;
}) {
  const rule = (
    <span
      className={cn('h-px bg-bnk-stroke-subtle', rules === 'flex' ? 'flex-1' : 'w-8')}
      aria-hidden
    />
  );

  return (
    <div className={cn('flex items-center gap-3', rules === 'flex' && 'w-full', className)}>
      {rules && rule}
      <p
        className={cn(
          'whitespace-nowrap font-clash font-medium uppercase tracking-[0.28em] text-bnk-brand',
          compact ? 'text-[10px]' : 'text-xs'
        )}
      >
        {TAGLINE}
      </p>
      {rules && rule}
    </div>
  );
}
